import React from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  notice: {
    display: "flex",
    textAlign: "left",
    fontSize: "10px",
    width: "100%",
    marginTop: "2px",
    marginLeft: "1.5em",
  },
  inputform: {
    width: "calc(100% - 30px)", marginTop: theme.spacing(2),
    borderRadius: "20px", display: "flex",
    alignItems: "center", height: "40px",
    fontSize: "16px", boxShadow: "0px 1px 2px gray",
    paddingLeft: "15px", paddingRight: "15px",
    '&:focus':{
      border: "2px solid "+theme.palette.primary.main,
      outline: "0",
    },
  },
  linkto: {
    color: "#c79100",
    cursor: "pointer",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    fontSize: "20px",
    fontWeight: "800",
    color: "#ffffff",
  }
}));

const AuthForm = props => {
  const classes = useStyles();
  const { handleSubmit, onChangeName, onChangeMail, onChangePass, onChangeTerms, checkedterms, enabledlogin, type } = props;

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      {onChangeName?
        <input
          className={classes.inputform}
          required
          fullWidth
          placeholder="表示名"
          name="name"
          label="表示名"
          id="name"
          onChange={onChangeName}
        />
      :
        null
      }
      <input
        required
        fullWidth
        placeholder="メールアドレス"
        id="email"
        label="Email Address"
        name="email"
        autoComplete="email"
        autoFocus
        type="email"
        style={{imeMode: "disabled"}}
        onChange={onChangeMail}
        className={classes.inputform}
      />
      <p className={classes.notice}>*4文字以上の半角英数字または記号</p>
      <input
        className={classes.inputform}
        required
        fullWidth
        placeholder="パスワード"
        name="password"
        label="Password"
        type="password"
        id="password"
        autoComplete="current-password"
        onChange={onChangePass}
      />
      <p className={classes.notice}>*6文字以上の半角英数字または記号</p>
      {onChangeTerms?
        <div style={{display: "flex", alignItems: "center"}}>
          <Checkbox
            checked={checkedterms}
            onChange={onChangeTerms}
            name="checkedterms"
            color="primary"
          />
          <label>
            <Link href="/kiyaku" target="_blank" className={classes.linkto}>利用規約</Link>
            及び
            <Link href="/kiyaku/privacy" target="_blank" className={classes.linkto}>プライバシーポリシー</Link>
            に同意する
          </label>
        </div>
      :
        null
      }
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        disabled={!enabledlogin}
        className={classes.submit}
      >
        {type}
      </Button>
    </form>
  );
};

export default AuthForm;